const formStyles = theme => ({
    flexRow: {
        display: "flex",
        direction: "column",
        '&>div': {
            flex: 1,
            width: "100%"
        }
    },
    actionContainer:{
        display: 'flex',
        justifyContent:'space-evenly',
        paddingTop:16
    },
    title:{
        color: theme.HeaderSelectedText,
    },
    fieldRoot: {
    },
    label:{
        color: theme.TextColor,
        transform:'translate(14px, 14px) scale(1)',
        fontSize:14,
        opacity:0.7
    },
    notchedOutline:{
    },
    inputRoot:{
        '& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline':{
                borderColor: `${theme.iconColor}`
        }

    },
    inputFocused:{},
    inputDisabled:{},
    inputError:{},
    inputField:{
        padding:12,
        fontSize: theme.textFontSize,
        color: theme.TextColor,
        height:"initial"
    },
    iconClass:{
        color: theme.iconColor,
        cursor:"pointer"
    },
    actionButton:{
        textTransform :'none',
        minWidth:120,
        '& $actionButtonDisabled':{
            cursor: "not-allowed",
            color: theme.iconColor,
            backgroundColor: theme.headerIconColor,
        },
        '&$actionOutlineDisabled':{
            borderColor: theme.iconColor,
            color: theme.iconColor
        }
    },
    actionButtonDisabled:{
    },
    actionOutlineDisabled:{

    },
    errorMessage:{
        padding:'16px 0px',
        color: theme.palette.error.main,
        fontSize: 14
    },
    circularProgress:{
        color:"white"
    },
    toggleContainer:{
        marginTop:16,
        fontSize:14,
        color: theme.gridTextColor,
        display: 'flex',
        alignItems: 'center'
    },
    toggleLabel:{
        width:'50%',
        display:'inline-block'
    },
    multilineInput:{
      '&$inputField':{
          padding:0
      }
    },
    updateFeederTerminalContainer: {
        padding: "0 20"
    },
    feederTerminalContainer: {
        padding: 20,
    },
    feederTerminalTitle: {
        fontWeight: 600,
        fontSize: theme.headerTextFontSize,
        lineHeight: "19px",
        color: theme.HeaderSelectedText,
        padding: 16,
        borderBottom: `1px solid ${theme.AppBGColor}`,
    }
});

export default formStyles;